var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NotificationBar from 'syf-component-library/ui/patterns/NotificationBar';
var NotificationBack = function (_a) {
    var notificationList = _a.notificationList, className = _a.className;
    return (_jsx("div", __assign({ className: className }, { children: notificationList.map(function (notification, index) {
            var notificationType = notification.notificationType, notificationIcon = notification.notificationIcon, description = notification.description, subDescription = notification.subDescription, _a = notification.fontAwesomeType, fontAwesomeType = _a === void 0 ? 'far' : _a;
            return (_jsx(NotificationBar, { "data-testid": "notifications-list-id", type: notificationType, icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: description, subTitle: subDescription }, "".concat(index + 1)));
        }) })));
};
export default NotificationBack;
